import moment from "moment";

/**
 * Chuẩn hóa hiển thị `DD/MM - HH:mm` (một ngày, không lặp sau dấu `-`).
 * Vd. "13/06 - 13/06 08:00" → "13/06 - 08:00"; "13/06 08:00" → "13/06 - 08:00".
 * @param {string} raw
 */
export function formatDateDashTimeDisplay(raw) {
  const t = String(raw ?? "").trim();
  if (!t) return t;

  let m = t.match(
    /^(\d{1,2}\/\d{1,2})\s*-\s*(\d{1,2}\/\d{1,2})\s+(\d{1,2}:\d{2}(?::\d{2})?)\s*$/
  );
  if (m) return `${m[1]} - ${m[3]}`;

  m = t.match(/^(\d{1,2}\/\d{1,2})\s+(\d{1,2}:\d{2}(?::\d{2})?)\s*$/);
  if (m && !/\s-\s/.test(t)) return `${m[1]} - ${m[2]}`;

  return t;
}

/**
 * Ghép `matchDate` (YYYY-MM-DD) + `kickoff` (thường chỉ "08:00") → `DD/MM - HH:mm`.
 * @param {string} [matchDate]
 * @param {string} [kickoff]
 */
export function formatMatchDateAndKickoff(matchDate, kickoff) {
  const k = kickoff != null ? String(kickoff).trim() : "";
  const md = matchDate != null ? String(matchDate).trim() : "";

  if (md && k) {
    const timeOnly = k.match(/^(\d{1,2}:\d{2}(?::\d{2})?)\s*$/);
    if (timeOnly) {
      const d = moment(md, "YYYY-MM-DD", true);
      if (d.isValid()) return `${d.format("DD/MM")} - ${timeOnly[1]}`;
    }
    return formatDateDashTimeDisplay(k);
  }

  if (k) return formatDateDashTimeDisplay(k);

  if (md) {
    const d = moment(md, "YYYY-MM-DD", true);
    if (d.isValid()) return d.format("DD/MM");
  }

  return "—";
}

/** @param {import("moment").Moment | null | undefined} m */
export function formatMomentDateDashTime(m) {
  if (!m || !m.isValid()) return "—";
  return `${m.format("DD/MM")} - ${m.format("HH:mm")}`;
}
